import {
  FilterValue,
  SelectFilter,
  StringFilterValue,
} from "../../types/filter";
import { getSelectedFilterValue } from "../../utils/filter/filtervalue";
import { createFilterValueFromSelectOption } from "../../utils/filter/selectfiltervalue";
import { AccordionSelect } from "../FilterAccordion/AccordionSelect";

interface InputSelectOptionProps {
  filter: SelectFilter;
  filterValues: FilterValue[];
  openFilters: string[];
  onChange: (value: FilterValue) => void;
  onOpenChange: (isOpen: boolean) => void;
}

export const InputSelectOption = ({
  filter,
  filterValues,
  openFilters,
  onChange,
  onOpenChange,
}: InputSelectOptionProps) => {
  const selected = getSelectedFilterValue(
    filter.id,
    filterValues,
    filter.defaultValue
  )! as StringFilterValue;
  return (
    <AccordionSelect
      filter={filter}
      selected={selected}
      onChange={(option) => {
        const value = createFilterValueFromSelectOption(filter.id, option);
        onChange(value);
      }}
      open={!!openFilters.find((filterId) => filterId === filter.id)}
      onOpenChange={onOpenChange}
    />
  );
};
